import { Context } from "chartjs-plugin-datalabels";

import { IColorPredicateOptions } from "../dashboard.color.helpers";
import { PieAPIParams } from "./dashboard-content.pie-chart-params-defs.dtos";

export interface IPieGraphContent {
  arcs: IPieGraphContentArc[];
}

export interface IPieGraphContentArc {
  value: number;
  params: PieAPIParams;
}

export interface IPieGraphSettings {
  fieldName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldValueToGetSecondaryValue?: any; // TODO: PieAPIParams[],
  labelsFormat: (arc: IPieGraphContentArc) => string;
  predicateFunctionColor: (options: IColorPredicateOptions) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataHook: (ele: any) => IPieGraphContent; // TODO: PieAPIParams[],
  legendFieldsFromParams: string[];
  legendDataHook: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arcsParams: Record<string, any>[], // TODO: PieAPIParams[],
    fields: string[],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Record<string, any>[]; //TODO : Partial<PieAPIParams>[] or PieAPILegendParams[];
}

export const contextManipulation = <T>(
  context: Context,
  minPercent: number = MIN_ARC_PERCENT_FOR_LABEL_SHOW_IN_PIE,
  optionTrue: T,
  optionFalse: T,
): T => {
  const value = context.dataset.data[context.dataIndex] as number;
  const dataArray = context.dataset.data as number[];
  const total = dataArray.reduce(
    (acc: number, curr: number) => Number(acc) + Number(curr),
    0,
  );
  const percentage = (value / total) * 100;
  return percentage >= minPercent ? optionTrue : optionFalse;
};

export const MIN_ARC_PERCENT_FOR_LABEL_SHOW_IN_PIE = 4.5;
